module.exports = __webpack_public_path__ + "img/nice-bus-america.6242ef38.jpg";